import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";

export type SwiperOptions<Value = string> = {
  value: Value;
  label: string;
}[];

type Orientation = "horizontal" | "vertical";

export type SwiperProps<Value = string> = {
  value: Value;
  onChange?: (value: Value) => void;
  options: SwiperOptions<Value>;
  orientation?: Orientation;
  disabled?: boolean;
};

export const Swiper = <Value = string,>({
  options,
  value,
  orientation = "horizontal",
  onChange,
  disabled,
}: SwiperProps<Value>) => {
  return (
    <div
      css={swiperStyles({
        orientation,
        count: options.length,
        disabled,
      })}
    >
      {options.map((option, index) => (
        <div
          key={index}
          onClick={() => {
            if (!disabled) {
              onChange?.(option.value);
            }
          }}
          css={swiperButton({ isActive: value === option.value, disabled })}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};

const swiperStyles =
  ({
    orientation,
    count,
    disabled,
  }: {
    orientation: Orientation;
    count: number;
    disabled?: boolean;
  }) =>
  (theme: ExactTheme) => css`
    display: flex;
    height: ${(orientation === "vertical" ? count : 1) * 20}px;
    flex-direction: ${orientation === "horizontal" ? "row" : "column"};
    //border: 1px solid ${theme.colorsV2[disabled ? "grey" : "blue"][500]};
    box-shadow: inset 0 0 0 1px
      ${theme.colorsV2[disabled ? "grey" : "blue"][500]};
    border-radius: 6px;

    overflow: hidden;
  `;
const swiperButton =
  ({ isActive, disabled }: { isActive: boolean; disabled?: boolean }) =>
  (theme: ExactTheme) => css`
    flex-grow: 1;
    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${theme.fontSizesV2.body2};
    font-weight: ${theme.fontWeights.normal};
    color: ${theme.colorsV2.grey[800]};
    cursor: ${disabled ? "not-allowed" : "pointer"};

    ${isActive &&
    css`
      background: ${theme.colorsV2[disabled ? "grey" : "blue"][500]};
      color: ${theme.colorsV2.white};
      font-weight: ${theme.fontWeights.medium};
    `};
  `;
